import { LIST_PRODUCTS_TYPE } from 'types/orders';
import './ProductsListCardSkeletonLoader.scss';

const ProductsListCardSkeletonLoader = ({ listProductsType }: { listProductsType: LIST_PRODUCTS_TYPE }) => {
  const isStockBord = listProductsType === LIST_PRODUCTS_TYPE.STOCK_BORD;

  return (
    <div className={`ProductsListCardSkeletonLoader ${isStockBord ? 'stockBord' : ''}`}>
      <div className="tableField serial">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField cliente">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField sku">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField name">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField pills">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField condition">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField location">
        <div className="skeletonLoader animationLoader" />
      </div>
      {listProductsType === LIST_PRODUCTS_TYPE.STOCK_BORD && (
        <div className="tableField stockStatus">
          <div className="skeletonLoader animationLoader" />
        </div>
      )}
      <div className="tableField referenceModel">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField actions">
        <div className="skeletonLoader animationLoader" />
      </div>
    </div>
  );
};

export default ProductsListCardSkeletonLoader;
